<template>
  <CModal alignment="center" size="lg" :visible="show" @close="closeModel">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">設定表單的選項</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <div id="editFromMatrix" class="options-box">
        使用換行表示個別選項。
        <!-- <span class="text-danger">上限五個</span> -->

        <div>
          <div
            class="d-flex align-items-center justify-content-start col-12 my-3"
            v-for="(option, i) in matrixOptions"
            :key="i"
          >
            <span class="col-1">{{ i + 1 }}</span>
            <input
              type="text"
              class="mx-3 content rounded px-3 w-50"
              v-model="option.title"
            />
            <div class="d-flex">
              <img
                src="@/assets/icons/add.svg"
                alt="add"
                @click="addOption(i)"
              />
              <img
                src="@/assets/icons/minus.svg"
                alt="minus"
                @click="deleteOption(i)"
              />
            </div>
            <div class="ms-2 col-3">
              <select class="col-12" v-model="option.type">
                <option
                  v-for="typeOption in typeOptions"
                  :value="typeOption.value"
                  :key="typeOption"
                >
                  {{ typeOption.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="finishAdd">完成</CButton>
      <CButton color="light" @click="closeModel"> 取消 </CButton>
    </CModalFooter>
  </CModal>
</template>
<script>
import { ref } from '@vue/reactivity'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [{ value: '欄位一', type: '1' }],
    },
  },
  emits: ['close', 'addOption'],
  setup(props, { emit }) {
    const matrixOptions = ref(props.options)
    const defaultOptions = matrixOptions.value
    const typeOptions = ref([
      { value: '1', label: '文字題' },
      { value: '2', label: '是非題' },
      { value: '3', label: '數字題' },
    ])
    const addOption = (index) => {
      const element = document.getElementById('editFromMatrix');
      matrixOptions.value.splice(index + 1, 0, { type: '1' })
      if(matrixOptions.value.length > 10){
        setTimeout(() => {
          element.scrollTop = element.scrollHeight;
          console.log(element.scrollHeight);
        }, 100);
      }
    }
    const closeModel = () => {
      matrixOptions.value = defaultOptions
      emit('close')
    }
    const deleteOption = (index) => {
      if (matrixOptions.value.length > 1) {
        matrixOptions.value.splice(index, 1)
      }
    }
    const finishAdd = () => {
      emit('close')
      emit('addOption', matrixOptions.value)
    }

    return {
      matrixOptions,
      addOption,
      deleteOption,
      closeModel,
      finishAdd,
      typeOptions,
    }
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 15px;
  margin: 0 10px;
}
.content {
  background-color: #fff;
  border: 1px solid #bdbdbd;
  outline: none;
  height: 30px;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.options-box {
  height: 500px;
  overflow: scroll;
}
select {
  height: 30px;
}
</style>
